<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-row>
        <el-button type="primary" @click="handleEdit(0, '','add')">新增短信配置</el-button>
      </el-row>
      <br/>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading">
        <el-table-column
          label="短信节点名字"
          prop="name">
        </el-table-column>

        <el-table-column
          label="状态"
          :formatter="statusFormat">
        </el-table-column>
        <el-table-column
          label="平台"
          prop="plugins.name">
        </el-table-column>
        <el-table-column
          label="平台状态"
          :formatter="platformStatusFormat">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row,'edit')">
              编辑
            </el-button>
            <el-button
              size="mini"
              type="danger"
              v-if="scope.row.status == 1"
              @click="handleDeleteAlert( scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close" v-loading="dialog.loading">
        <el-form :model="snsTemplate">
          <el-form-item label="节点名称" label-width="100px">
            <el-input v-model="snsTemplate.name" auto-complete="off"></el-input>
          </el-form-item>


          <el-form-item label="状态" label-width="100px">
            <el-switch
              v-model="snsTemplate.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="启用"
              inactive-text="不启用"
              active-value="2"
              inactive-value="1">
            </el-switch>
          </el-form-item>
          <el-form-item label="发送节点" label-width="100px">
            <el-select v-model="snsTemplate.node_id" placeholder="请选择">
              <el-option
                v-for="(item,key) in nodes"
                :key="key"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="平台" label-width="100px">
            <el-select v-model="snsTemplate.plugin_id" placeholder="请选择" @change="brandChange">
              <el-option
                v-for="(item,key) in brands"
                :key="key"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <div v-for="(item,key) in snsTemplate.params" :key="key">
            <div v-if="item.displayType == 2">
              <el-form-item :label="item.labelName" label-width="100px">
                <el-input v-model="item.cvalue" auto-complete="off" :placeholder="item.placeholder" v-if="item.eleType == 1"></el-input>
                <div v-else-if="item.eleType == 2">
                  <el-upload
                    v-if="item.cvalue == ''"
                    :action="uploadUrl+'?key='+key"
                    :on-success="handleSuccess"
                    :limit="1">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">{{item.placeholder}}</div>
                  </el-upload>
                  <div v-else>
                    已上传{{key}}文件  <el-button size="small" type="danger" @click="item.cvalue = ''">删除</el-button>
                  </div>
                </div>
                <div v-else-if="item.eleType == 4">
                  <el-switch
                    v-model="item.cvalue"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="开启"
                    inactive-text="关闭"
                    active-value="true"
                    inactive-value="false">
                  </el-switch>
                </div>
                <el-alert
                  v-if="item.placeholder"
                  :title="item.placeholder"
                  type="success">
                </el-alert>
              </el-form-item>
            </div>
          </div>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      loading:false,
      snsTemplate:{
        id:0,
        name:"",
        params:[],
        status:1,
        plugin_id:0,
        node_id:0,
      },

      dialog:{
        dialogFormVisible:false,
        title:"新增打印机",
        close:false,
        loading:false,
      },

      tmpParams:[],
      tmp_plugin_id:0,

      tableData: [],
      brands:[],
      nodes:[],
      modelChecks:[],
    }
  },
  created(){
    this.initData();
  },
  methods: {
    initData(){
      this.loading = true;
      var that = this;
      that.$api.get('/store/sns_template', {}, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            that.tableData = res.data.sns_templates;
          }else{
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });
    },


    statusFormat(row,column){
      return row.status == 2?"启用中":"未启用";
    },
    platformStatusFormat(row,column){
      return row.plugins.used?"启用中":"未启用";
    },

    handleEdit(index, row,action) {
      this.modelChecks = [];
      this.loading = true;
      var that = this;

      this.tmpParams = [];
      this.tmp_plugin_id = 0;

      that.$api.get('/store/sns_template/platforms_and_nodes', that.pages, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            that.brands = res.data.sns_plugins;
            this.nodes = res.data.sns_nodes;
            if(action == "edit"){
              this.dialog.title = "配置:"+row.name;
              this.snsTemplate.id = row.id;
              this.snsTemplate.name = row.name;
              this.snsTemplate.status = ""+row.status;
              this.snsTemplate.plugin_id = row.plugins.id;
              this.snsTemplate.node_id = row.node_id;
              this.snsTemplate.params = row.params;


              this.tmpParams = row.params;
              this.tmp_plugin_id = row.plugins_id;
              console.log(this.snsTemplate);
            }else{
              this.dialog.title = "新增打印机";
              this.snsTemplate.id = 0;
              this.snsTemplate.plugin_id = that.brands[0].id;
              this.snsTemplate.node_id = that.nodes[0].index;
              this.snsTemplate.name = that.brands[0].name;
              this.snsTemplate.status = "1"
              this.snsTemplate.params = that.brands[0]['pluginsParams'];
            }
            console.log(this.snsTemplate);
            this.dialog.dialogFormVisible = true;

          }else{
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
        this.loading = false;
      });
    },
    handleDeleteAlert(row) {
      this.$confirm('此操作将删除该配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(row);
      }).catch(() => {

      });
    },
    handleDelete(row) {
      this.loading = true;
      var that = this;
      that.$api.delete('/store/sns_template/'+row.id, null, response => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var res = response.data;
          if (res.code == 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.initData();
          }else{
            this.$message({
              message: res.msg,
              type: 'warning'
            });

            this.loading = false;
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });

          this.loading = false;
        }

      });
    },
    in_array(search,array){
      for(var i in array){
        if(array[i]==search){
          return true;
        }
      }
      return false;
    },
    brandChange(plugin_id){

      let that = this;
      if(plugin_id == this.tmp_plugin_id){//选择原来的
        this.snsTemplate.params = this.tmpParams;
      }else{
        this.brands.forEach(function(value,i){
          if(value.id == plugin_id){
            that.snsTemplate.params = value['pluginsParams'];
          }
        });
      }
      console.log(that.snsTemplate);
    },

    handleSave() {
      this.dialog.loading = true;
      var that = this;
      that.snsTemplate.params = JSON.stringify(that.snsTemplate.params);
      that.$api.post('/store/sns_template', that.snsTemplate, response => {
        if (response.status >= 200 && response.status < 300) {
          console.log(response.data);
          var res = response.data;
          if (res.code == 0) {
            this.$message({
              message: that.dialog.title+'成功',
              type: 'success'
            });

            this.dialog.loading = false;
            this.dialog.dialogFormVisible = false;
            this.initData();
          }else{
            this.$message({
              message: res.msg,
              type: 'warning'
            });

            this.dialog.loading = false;
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });

          this.dialog.loading = false;
        }

      });

    },
  },
}
</script>

<style lang="less">
@import '../../style/mixin';
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.table_container{
  padding: 20px;
  text-align: left;
}
.Pagination{
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/store/SnsTemplateNodes.vue